// extracted by mini-css-extract-plugin
module.exports = {"duda-integration-page":"DudaIntegrationPage_duda-integration-page__3EzSf","go-to-store-page-button":"DudaIntegrationPage_go-to-store-page-button__3EuNB"};